import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=f5f40146&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5f40146')) {
      api.createRecord('f5f40146', component.options)
    } else {
      api.reload('f5f40146', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=f5f40146&", function () {
      api.rerender('f5f40146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27jJM3RswaXhi/JS/imageCarousel.vue"
export default component.exports